import type { BaseRouteType, BaseMethodType } from '../types.ts'
import { z } from "zod";
export const tagsPostCollection_points_collectionPointIdMeter_code = z.any()
export type TagsPostCollection_points_collectionPointIdMeter_code = z.infer<typeof tagsPostCollection_points_collectionPointIdMeter_code>

export const paramsPostCollection_points_collectionPointIdMeter_code = z.object({ "collectionPointId": z.string() })
export type ParamsPostCollection_points_collectionPointIdMeter_code = z.infer<typeof paramsPostCollection_points_collectionPointIdMeter_code>

export const bodyPostCollection_points_collectionPointIdMeter_code = z.object({ "meterCodes": z.array(z.string()) })
export type BodyPostCollection_points_collectionPointIdMeter_code = z.infer<typeof bodyPostCollection_points_collectionPointIdMeter_code>

export const responsePostCollection_points_collectionPointIdMeter_code = z.any()
export type ResponsePostCollection_points_collectionPointIdMeter_code = z.infer<typeof responsePostCollection_points_collectionPointIdMeter_code>

interface IPostCollection_points_collectionPointIdMeter_code extends BaseMethodType {
  tags: TagsPostCollection_points_collectionPointIdMeter_code,
  params: ParamsPostCollection_points_collectionPointIdMeter_code,
  body: BodyPostCollection_points_collectionPointIdMeter_code,
  response: ResponsePostCollection_points_collectionPointIdMeter_code
}
export const URL = '/collection-points/:collectionPointId/meter-code'
export const validation = {
  post: {
    tags: tagsPostCollection_points_collectionPointIdMeter_code,
    params: paramsPostCollection_points_collectionPointIdMeter_code,
    body: bodyPostCollection_points_collectionPointIdMeter_code,
    response: responsePostCollection_points_collectionPointIdMeter_code
  }
}
export interface Collection_points_collectionPointIdMeter_code extends BaseRouteType {
  post: IPostCollection_points_collectionPointIdMeter_code
}